var React = require('react');

function Person (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.01001 2C9.11001 2 10.01 2.9 10.01 4C10.01 5.1 9.11001 6 8.01001 6C6.91001 6 6.01001 5.1 6.01001 4C6.01001 2.9 6.91001 2 8.01001 2ZM8.01001 0C5.80001 0 4.01001 1.79 4.01001 4C4.01001 6.21 5.80001 8 8.01001 8C10.22 8 12.01 6.21 12.01 4C12.01 1.79 10.22 0 8.01001 0ZM10.68 9H5.34001C4.41001 9 3.47 9.74 3.22 10.66L2 16H4.01001L5.01001 11H11.01L11.98 16H14.01L12.8 10.66C12.55 9.74 11.61 9 10.68 9Z","fill":"#A5AEB6"}));
}

Person.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Person;

Person.default = Person;
